var global = require('../internals/global');
var inspectSource = require('../internals/inspect-source');

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/native-weak-map.js
// module id = 1665
// module chunks = 1